// extracted by mini-css-extract-plugin
module.exports = {"commonHeader":"styles_commonHeader__BxCxB","pageHeaderContent":"styles_pageHeaderContent__TUetj"};